import { GENRE_ICON_BY_ID } from "@nf/constants";
import { forwardRef, useEffect, useState } from "react";
import dynamic from "next/dynamic";
import type { LottieRef, LottieRefCurrentProps } from "lottie-react";

const Lottie = dynamic(() => import("lottie-react"), { ssr: false });

interface GenreAnimatedIconProps {
  genreId: string | number;
}

const GenreAnimatedIcon = forwardRef<
  LottieRefCurrentProps,
  Omit<React.ComponentProps<typeof Lottie>, "animationData"> &
    GenreAnimatedIconProps
>(({ genreId, ...props }, ref) => {
  const [animationData, setAnimationData] = useState<unknown>(null);

  useEffect(() => {
    const loadAnimation = async () => {
      try {
        const data = await import(
          `resources/categories/${GENRE_ICON_BY_ID[genreId]}`
        );
        setAnimationData(data);
      } catch (error) {
        console.warn("Failed to load animation:", error);
      }
    };

    loadAnimation();
  }, [genreId]);

  if (!animationData) {
    return null;
  }

  return (
    <Lottie
      {...props}
      lottieRef={ref as LottieRef}
      animationData={animationData}
    />
  );
});

export default GenreAnimatedIcon;
